import type { ReactNode } from 'react';

export const symbol_splitscreen_landscape: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M540-280h190q12.75 0 21.38-8.63Q760-297.25 760-310v-340q0-12.75-8.62-21.38Q742.75-680 730-680H540q-12.75 0-21.37 8.62Q510-662.75 510-650v340q0 12.75 8.63 21.37Q527.25-280 540-280Zm-310 0h190q12.75 0 21.38-8.63Q450-297.25 450-310v-340q0-12.75-8.62-21.38Q432.75-680 420-680H230q-12.75 0-21.37 8.62Q200-662.75 200-650v340q0 12.75 8.63 21.37Q217.25-280 230-280Zm-90 120q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm680-580H140v520h680v-520Zm-680 0v520-520Z"
		/>
	</svg>
);
